import React from "react";
import { Card, Form, Input, Button } from "antd";
import { toast } from "react-toastify";

export default function LoginPage({ onLogin }) {
  const handleLogin = (values) => {
    if (values.username === "admin" && values.password === "admin") {
      onLogin();
    } else {
      toast.error("Неправильний логін або пароль");
    }
  };

  return (
    <div style={{ width: 300, margin: "100px auto" }}>
      <Card title="Вхід до системи">
        <Form onFinish={handleLogin}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: "Введіть логін" }]}
          >
            <Input placeholder="Логін" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Введіть пароль" }]}
          >
            <Input.Password placeholder="Пароль" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Увійти
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
